// AIGenerateList.tsx
import React, { useContext, useEffect, useState } from "react";
import styles from "./AIGenerateList.module.css";
import QuestionAnswerCard from "./QuestionAnswerCard";
import { EditablePair } from "../../../../../api/responsePayload/KnowledgeResponse";
import { showConsoleError } from "../../../../../util/ConsoleMessage";
import { DialogContext } from "../../../../../context/DialogContext";
import {
  DialogShownFromType,
  DialogStyle,
} from "../../../../../components/dialog/Dialog";
import { KowledgeContentBulkCreate } from "../../../../../api/KnowledgeContentApiCall";
import {
  useAppSelector,
  useAppDispatch,
} from "../../../../../store/common/hooks";
import { setCallApproveApi } from "../../../../../store/context.slice";

interface AIGenerateListProps {
  loading: boolean;
  contextId: number;
  pairs: EditablePair[];
  onUpdatePair: (
    index: number,
    updatedFields: Partial<EditablePair>,
    removePair?: EditablePair
  ) => void;
  onQuestionAnswerChange: (
    index: number,
    question: string,
    answer: string
  ) => void;
}

const AIGenerateList: React.FC<AIGenerateListProps> = ({
  loading,
  contextId,
  pairs,
  onUpdatePair,
  onQuestionAnswerChange,
}) => {
  const [pairsValue, setPairsValue] = useState<EditablePair[]>(pairs);
  const { showDialog } = useContext(DialogContext);
  const [selectedPair, setSelectedPair] = useState<EditablePair>();
  const [lastIndex, setLastIndex] = useState<number>();
  const reduxApproveApiCall = useAppSelector(
    (state) => state.context.callApproveApi
  );
  const dispact = useAppDispatch();
  useEffect(() => {
    setPairsValue(pairs);
  }, [pairs]);

  useEffect(() => {
    if (reduxApproveApiCall) {
      callApproveApi();
      dispact(setCallApproveApi({ isSelected: false }));
    }
  }, [reduxApproveApiCall]);

  if (loading) {
    return (
      <div className={styles["spinner-container"]}>
        <div className={styles.spinner}></div>
      </div>
    );
  }

  const callApproveApi = async () => {
    if (
      selectedPair != undefined &&
      lastIndex != undefined &&
      selectedPair.question != ""
    ) {
      await KowledgeContentBulkCreate({ [contextId]: [selectedPair] });
      onUpdatePair(lastIndex, {}, selectedPair);
    }
  };

  const handleApprove = async (index: number, selectedPairs: EditablePair) => {
    try {
      setSelectedPair(selectedPairs);
      setLastIndex(index);
      showDialog(
        DialogStyle.Default,
        contextId,
        selectedPairs.question ?? "",
        selectedPairs.answer,
        DialogShownFromType.Context
      );
    } catch (e) {
      showConsoleError(e);
    }
  };

  return (
    <div className={styles["main-container"]}>
      {pairsValue.map((pair, index) => (
        <QuestionAnswerCard
          key={`${contextId}-${pair.id}`}
          question={pair.question}
          answer={pair.answer}
          setSelectedCategory={(id) => onUpdatePair(index, { category_id: id })}
          setSubSelectedCategory={(id) =>
            onUpdatePair(index, { subcategory_id: id })
          }
          defaultSelectedCategory={pair.category_id}
          defaultSelectedSubCategory={pair.subcategory_id}
          defaultChecked={pair.selected}
          onCheckedChange={(val) => onUpdatePair(index, { selected: val })}
          onQuestionAnswerChanged={(question, answer) =>
            onQuestionAnswerChange(index, question, answer)
          }
          approveCallback={() => handleApprove(index, pair)}
        />
      ))}
    </div>
  );
};

export default AIGenerateList;
